import React from "react";
import { useHistory } from "react-router-dom";
import DashboardLayout from "../../layouts/Dashboard";
import CRUDTable from "../../components/CRUD/CRUDTable";
import { planResultCRUD } from "../../http";
import { PLAN_RESULT_DETAIL_ROUTE } from "../../routes/const";
import useReload from "../../hooks/useReload";
import { formatDateAsDate } from "../../functions/formatters";

const toBoolLabel = (v) => (v ? "Да" : "Нет");

export default function PlanResultList() {
  const { push } = useHistory();
  const { reloadValue } = useReload();

  const columns = React.useMemo(
    () => [
      { title: "Id", dataIndex: "id", key: "id", width: 90, fixed: "left" },
      {
        title: "Создан",
        dataIndex: "createdAt",
        key: "createdAt",
        width: 150,
        render: (v) => (v ? formatDateAsDate(v) : "—"),
      },
      {
        title: "Период с",
        dataIndex: "fromDate",
        key: "fromDate",
        width: 150,
        render: (v) => (v ? formatDateAsDate(v) : "—"),
      },
      {
        title: "Период по",
        dataIndex: "endDate",
        key: "endDate",
        width: 150,
        render: (v) => (v ? formatDateAsDate(v) : "—"),
      },
      {
        title: "Месяц",
        dataIndex: "month",
        key: "month",
        width: 150,
        render: (v) => (v ? formatDateAsDate(v) : "—"),
      },
      {
        title: "Квартал",
        dataIndex: "quartal",
        key: "quartal",
        width: 150,
        render: (v) => (v ? formatDateAsDate(v) : "—"),
      },
      {
        title: "Полугодие",
        dataIndex: "halfYear",
        key: "halfYear",
        width: 150,
        render: (v) => (v ? formatDateAsDate(v) : "—"),
      },
      {
        title: "Филиал",
        dataIndex: "filial",
        key: "filial",
        width: 220,
        render: (v) => v?.name || "—",
      },
      {
        title: "Подразделение",
        dataIndex: "filialDivision",
        key: "filialDivision",
        width: 260,
        render: (v) => v?.name || "—",
      },
      {
        title: "Подписан",
        dataIndex: "isSigned",
        key: "isSigned",
        width: 120,
        render: (v) => toBoolLabel(Boolean(v)),
      },
      { title: "State", dataIndex: "state", key: "state", width: 110 },
    ],
    []
  );

  return (
    <DashboardLayout>
      <CRUDTable
        search={planResultCRUD.search}
        columns={columns}
        onClickCreateButton={null}
        onClickEditButton={null}
        onClickDeleteButton={null}
        onClickDetailsButton={(id) => push(PLAN_RESULT_DETAIL_ROUTE(id))}
        reloadValue={reloadValue}
        extraQuery={{
          includes: ["Filial", "FilialDivision"],
        }}
      />
    </DashboardLayout>
  );
}

